import { render, staticRenderFns } from "./PersonRiskDonutChart.vue?vue&type=template&id=2d9907e7&scoped=true"
import script from "./PersonRiskDonutChart.vue?vue&type=script&lang=js"
export * from "./PersonRiskDonutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9907e7",
  null
  
)

export default component.exports